import api from './api'

const getLocale = () => {
  const locale = localStorage.getItem('locale')
  return locale === 'fr' ? 'fr' : 'en'
}

export default {
  getGoalCategories() {
    return api.get('/goal-categories', { params: { locale: getLocale() } })
  },

  getSkillGroups(params = {}) {
    return api.get('/reference/skill-groups', { params })
  },

  getSectors(params = {}) {
    return api.get('/reference/sectors', { params })
  },

  getSkills(params = {}) {
    const { search, q, ...rest } = params
    const query = q ?? search

    return api.get('/reference/skills', {
      params: {
        ...rest,
        ...(query ? { q: query } : {}),
      },
    })
  },
}
